import { App } from './app.class';
import { Notification } from './notification.class';
import { Fetch } from '../fetch.class';
import { Popup } from './popup.class';
import * as Sqrl from 'squirrelly';
import Upgrademodal from './upgrademodal.class';

export class Page {

    constructor() {

        // Intervall für Prozessoren-Reload
        this.intervalReload = null;

        // Templates
        this.tplProcessorsActive = Sqrl.compile( document.getElementById('tpl_processors_active').innerHTML.replace(/=&gt;/g, '=>') );
        this.tplProcessorsAdd = Sqrl.compile( document.getElementById('tpl_processors_add').innerHTML.replace(/=&gt;/g, '=>') );

        // Elemente
        this.$contentProcessorsActive = document.querySelector('#content_processors_active');
        this.$contentProcessorsAdd = document.querySelector('#content_processors_add');

        // Daten
        this.form_code = this.$contentProcessorsActive.dataset.formCode;

        // Klick-Events bei Prozessoren
        document.addEventListener('click', event => {

            // Aktivieren
            if(event.target && event.target.matches('*[data-processor-activate]')) {
                event.preventDefault();

                // Pro-Feature
                const isPro = event.target.classList.contains("pro") ? true : false;
                const proStatus = this.$contentProcessorsActive.dataset.isPro === "true" ? true : false;

                if(isPro == true && proStatus != true) {

                    // Upgrade
                    const successMsg = event.target.dataset.upgradeSuccessmsg ?? '';
                    const processor = event.target.dataset.processorActivate ?? '';
                    let upgradeType = "";
                    if(processor == "Autoresponse")     upgradeType = 'autoresponse';
                    else if(processor == "Whatsapp")    upgradeType = 'whatsapp';
                    Upgrademodal.open(
                        () => {

                            // Pro-Status vermerkten
                            this.$contentProcessorsActive.dataset.ispro = "true";

                            // Erfolgsmeldung
                            new Notification().success("Upgrade", successMsg);
                        },
                        upgradeType
                    );
                }

                // Aktivierung ausführen
                else {
                    this.activateProcessor( event.target.dataset.processorActivate );
                    this.$contentProcessorsActive.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }

            // Deaktivieren
            else if(event.target && event.target.matches('*[data-processor-deactivate]')) {
                event.preventDefault();
                this.deactivateProcessor( event.target.dataset.processorDeactivate );
            }
        });

        // Prozessoren laden
        this.loadProcessors();
    }

    // Prozessoren laden
    loadProcessors() {

        // Interval zurücksetzen
        if(this.intervalReload)
            clearInterval(this.intervalReload);

        // Daten abrufen
        new Fetch().get(App.getUrl('form', 'delivery_processors_load', this.form_code))
        .then(response => {

            // Inhalt aus Template erstellen
            this.$contentProcessorsActive.innerHTML = this.tplProcessorsActive(response, Sqrl.defaultConfig);
            this.$contentProcessorsAdd.innerHTML = this.tplProcessorsAdd(response, Sqrl.defaultConfig);

            // PopUps initialisieren
            const popups_active = this.$contentProcessorsActive.querySelectorAll(".popup");
            const popups_add = this.$contentProcessorsAdd.querySelectorAll(".popup");
            const popups = [...popups_active, ...popups_add];
            popups.forEach($ele => {
                const p = new Popup($ele, instance => {
                    window.Popups.forEach(p => {
                        if(p !== instance) {
                            p.close();
                        }
                    });
                });
                window.Popups.push(p);
            });
        })
        .catch(error => {

        })
        .finally(() => {

            // Prozessoren alle 20 Sek. neu laden
            //this.intervalReload = setInterval(() => { this.loadProcessors() }, 20000);
        });
    }

    // Prozessor aktivieren
    activateProcessor(code) {

        // Sendedaten
        const data = new FormData();
        data.append("form_code", this.form_code);
        data.append("processor", code);

        // Senden
        new Fetch().post(App.getUrl('form', 'activate_delivery_processor'), data)
        .then(response => {

            // Erfolgsmeldung
            new Notification().success(response.msg);

            // Anzeige neu laden
            this.loadProcessors();
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error(error.message);
        });
    }

    // Prozessor deaktivieren
    deactivateProcessor(code) {

        // Sendedaten
        const data = new FormData();
        data.append("form_code", this.form_code);
        data.append("processor", code);

        // Senden
        new Fetch().post(App.getUrl('form', 'deactivate_delivery_processor'), data)
        .then(response => {

            // Erfolgsmeldung
            new Notification().success(response.msg);

            // Anzeige neu laden
            this.loadProcessors();
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error(error.message);
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-delivery')) {
        new Page();
    }
});